var _g, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4084",
    "data-name": "Group 4084",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.998,
    height: 31.593,
    viewBox: "0 0 31.998 31.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    transform: "translate(0 6.189) rotate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M0,14.071a.64.64,0,0,0,.053-.119,2.481,2.481,0,0,1,1.212-1.676Q3.126,11.188,5,10.115c.341-.2.561-.126.773.242q1.4,2.43,2.8,4.863c.045.078.087.159.138.232a.449.449,0,0,0,.791-.416,1.629,1.629,0,0,0-.135-.263q-1.4-2.432-2.8-4.863c-.26-.451-.231-.608.184-.9A28.583,28.583,0,0,0,14.4.984a1.924,1.924,0,0,1,3.4.076q3.151,5.457,6.29,10.921a1.95,1.95,0,0,1-1.7,3.008,27.4,27.4,0,0,0-11.642,3.089c-1.553.808-3.036,1.749-4.558,2.615a2.436,2.436,0,0,1-2.811-.13,2.785,2.785,0,0,1-.726-.818c-.779-1.3-1.534-2.625-2.28-3.949A7.544,7.544,0,0,1,0,14.883Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M3.567,6.9A1.484,1.484,0,0,1,2.3,6.18C1.548,4.91.816,3.63.084,2.351a.443.443,0,0,1,.18-.668Q1.647.871,3.04.076a.439.439,0,0,1,.648.177C4.432,1.536,5.181,2.818,5.9,4.115a1.441,1.441,0,0,1-.439,1.878,12.939,12.939,0,0,1-1.356.773A2.4,2.4,0,0,1,3.567,6.9Z",
    transform: "translate(6.86 19.533)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2756",
    "data-name": "Rectangle 2756",
    width: 4.443,
    height: 1.111,
    rx: 0.555,
    transform: "translate(20.382 3.886) rotate(-61)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2758",
    "data-name": "Rectangle 2758",
    width: 4.443,
    height: 1.111,
    rx: 0.555,
    transform: "translate(27.444 11.969) rotate(-8)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6932",
    "data-name": "Rectangle 6932",
    width: 4.443,
    height: 1.111,
    rx: 0.555,
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 25.445, 6.909)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarms);
export default __webpack_public_path__ + "static/media/alarms.fee2331e.svg";
export { ForwardRef as ReactComponent };